import 'styles/global';

import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { createBrowserHistory } from 'history';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@qga/roo-ui';
import { ModalGlobalStyle } from '@qga/roo-ui/components';
import * as Sentry from '@sentry/browser';
import { ROUTER_BASENAME } from 'config/env';
import theme from 'styles/theme';
import App from 'components/App';
import routes from './routes';
import { FeatureFlagsProvider } from 'hooks/useFeatureFlag';
import { QffUserProvider } from 'hooks/useQffUser';
import { GlobalModalProvider } from 'hooks/useGlobalModal';

export const initialize = () => {
  const history = createBrowserHistory({ basename: ROUTER_BASENAME });

  const root = document.getElementById('root');

  history.listen((location) => {
    window.dataLayer.push({ event: 'gaPageview' });

    Sentry.addBreadcrumb({
      category: 'route-change',
      message: location.pathname,
      data: { pathname: location.pathname, search: location.search },
      level: 'info',
    });
  });

  Modal.setAppElement(root);

  ReactDOM.render(
    <BrowserRouter basename={ROUTER_BASENAME}>
      <QffUserProvider>
        <ThemeProvider theme={theme}>
          <GlobalModalProvider>
            <ModalGlobalStyle />
            <FeatureFlagsProvider>
              <App>{routes}</App>
            </FeatureFlagsProvider>
          </GlobalModalProvider>
        </ThemeProvider>
      </QffUserProvider>
    </BrowserRouter>,
    root,
  );
};
